const storageAvailable = type => {
  let storage;
  try {
    storage = window[type];
    const x = "__storage_test__";
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return e instanceof DOMException && e.name === "QuotaExceededError" && storage && storage.length !== 0;
  }
};
document.addEventListener("DOMContentLoaded", function () {
  class OfferFilters extends HTMLElement {
    #namespace = ".c-offer-filters";
    #animation = null;
    #boundHandleClose;
    #boundHandleToggle;
    #boundHandleResize;
    #boundHandleScroll;
    #boundHandleFilter;
    #active = false;
    #expanded = false;
    #running = false;
    constructor() {
      super();
      this.elClose = this.querySelector(`${this.#namespace}__close`);
      this.elToggle = this.querySelector(`${this.#namespace}__toggle`);
      this.elPanel = this.querySelector(`${this.#namespace}__panel`);
      this.elActions = this.querySelector(`${this.#namespace}__actions`);
      this.elForm = this.querySelector(`${this.#namespace}__form`);
      this.elSubmit = this.querySelector(`${this.#namespace}__submit`);
      this.elsInputs = this.elPanel.querySelectorAll(".c-input-checkbox__input");
      this.elGlobalFooter = document.querySelector(".s-footer");
      this.elGlobalHeader = document.querySelector(".s-header__wrapper");
      if (this.elToggle === null || this.elPanel === null) return;
      this.#boundHandleClose = this.#handleClose.bind(this);
      this.#boundHandleToggle = this.#handleToggle.bind(this);
      this.#boundHandleResize = this.#handleResize.bind(this);
      this.#boundHandleScroll = this.#handleScroll.bind(this);
      this.#boundHandleFilter = this.#handleFilter.bind(this);
      this.elClose.addEventListener("click", this.#boundHandleClose);
      this.elToggle.addEventListener("click", this.#boundHandleToggle);
      if (this.elForm === null || this.elsInputs.length === 0) return;
      this.elSubmit.addEventListener("click", this.#boundHandleToggle);
      for (const input of this.elsInputs) {
        input.addEventListener("change", this.#boundHandleFilter);
      }
    }
    connectedCallback() {
      window.addEventListener("resize", this.#boundHandleResize);
      window.addEventListener("scroll", this.#boundHandleScroll);
      this.#handleResize();
    }
    disconnectedCallback() {
      window.removeEventListener("resize", this.#boundHandleResize);
      window.removeEventListener("scroll", this.#boundHandleScroll);
    }
    #handleResize() {
      if (window.innerWidth < 992) {
        this.#active = true;
        this.#expanded = this.#restore("filtersExpanded") === "true" ?? false;
        if (this.#expanded) {
          this.#expand(false);
        }
        return;
      }
      if (this.#animation) {
        this.#animation.cancel();
      }
      if (this.#active) {
        document.body.style.overflow = "";
        this.elPanel.removeAttribute("style");
        this.elToggle.removeAttribute("style");
        this.elSubmit.removeAttribute("style");
        this.#active = false;
        this.#expanded = false;
        this.#unstore();
      }
    }
    #handleClose(event) {
      event.preventDefault();
      if (this.#animation) {
        this.#animation.cancel();
      }
      this.#expanded = false;
      this.#collapse();
      this.#store("filtersExpanded", this.#expanded);
    }
    #handleToggle(event) {
      event.preventDefault();
      if (this.#animation) {
        this.#animation.cancel();
      }
      this.#expanded = !this.#expanded;
      if (this.#expanded) {
        this.#expand();
      } else {
        this.#collapse();
      }
      this.#store("filtersExpanded", this.#expanded);
    }
    #handleFilter(event) {
      const input = event.target;
      if (this.elForm === null || !input) return;
      this.elForm.submit();
    }
    #expand(animated = true) {
      document.body.style.overflow = "hidden";
      this.elPanel.style.visibility = "visible";
      this.elToggle.style.display = "none";
      this.elSubmit.style.display = "block";
      if (!animated) {
        this.#animation && this.#animation.cancel();
        this.elPanel.style.opacity = 1;
        this.elPanel.style.transform = "translateY(0)";
        return;
      }
      this.#animation = this.#animate({
        opacity: [0, 1],
        transform: ["translateY(16px)", "translateY(0)"]
      });
    }
    #collapse() {
      this.elSubmit.style.display = "none";
      this.elToggle.style.display = "block";
      this.#animation = this.#animate({
        opacity: [1, 0],
        transform: ["translateY(0)", "translateY(16px)"]
      });
      this.#animation.onfinish = () => {
        document.body.style.overflow = "";
        this.elPanel.style.visibility = "hidden";
      };
    }
    #animate({
      opacity,
      transform
    }) {
      return this.elPanel.animate({
        opacity,
        transform
      }, {
        duration: 300,
        easing: "ease-in-out",
        fill: "both"
      });
    }
    #handleScroll() {
      if (window.innerWidth < 992) return;
      if (this.#running) return;
      this.#running = true;
      requestAnimationFrame(() => {
        this.#running = false;
        const footerDelta = this.elGlobalFooter.getBoundingClientRect().top - window.innerHeight;
        const headerOffset = this.elGlobalHeader.offsetHeight + this.elGlobalHeader.getBoundingClientRect().top;
        if (footerDelta < 0) {
          const forcedHeight = window.innerHeight - headerOffset + footerDelta;
          this.style.height = `${forcedHeight}px`;
          this.style.transition = "none";
        } else {
          this.removeAttribute("style");
        }
      });
    }
    #store(key, value) {
      if (!storageAvailable("sessionStorage")) return;
      sessionStorage.setItem(key, value);
    }
    #restore(key) {
      if (!storageAvailable("sessionStorage")) return;
      return sessionStorage.getItem(key);
    }
    #unstore() {
      if (!storageAvailable("sessionStorage")) return;
      sessionStorage.clear();
    }
  }
  customElements.define("offer-filters", OfferFilters);
});